import React, { MouseEventHandler } from 'react';

import Container, { ContainerTypes } from '@/components/commons/page-elements/Container';
import Heading, { HeadingSizes } from '@/components/commons/page-elements/Heading';
import Button, { ButtonSize, ButtonType } from '@/components/commons/button';

interface Props {
    readonly heading: {
        readonly size?: HeadingSizes;
        readonly externalStyles?: string;
        readonly bold?: boolean;
        readonly children: Element;
    };
    readonly body: {
        readonly text: string;
        readonly style?: string;
    };
    readonly image?: {
        readonly src?: string;
        readonly alt?: string;
        readonly style?: string;
    };
    readonly button?: {
        readonly text?: string;
        readonly style?: string;
        readonly size?: ButtonSize;
        readonly type?: ButtonType;
        readonly onClick?: MouseEventHandler;
    };
    readonly externalStyles?: string;
    readonly alpha?: boolean;
}

/**
 * Component used to add consistent styling for Headings throughout
 * the app, also supports externalStyles if tweaks are needed.
 */
function NavigationCard({
    heading,
    body,
    image = null,
    button = null,
    externalStyles = '',
    alpha = false,
}: Props) {
    return (
        <Container type={ContainerTypes.WHITE} externalStyles={`flex items-center justify-center ${externalStyles}`}>
            <div className="flex flex-col gap-4 items-center content-between h-full w-full">
                {image && <img src={image.src} alt={image.alt} className={image.style} />}
                <div className="w-full">
                    <Heading
                        externalStyles={heading.externalStyles}
                        bold={heading.bold}
                        size={heading.size}
                    >
                        {heading.children}
                        {alpha ? <span className="bg-cirrusWhite border border-lightGray rounded ml-2 p-1 px-2">Alpha</span> : ''}
                    </Heading>
                    <p className={body.style}>
                        {body.text}
                    </p>
                </div>
                {button
                    && (
                        <Button
                            size={button.size}
                            type={button.type}
                            externalStyles={button.style}
                            text={button.text}
                            onClick={button.onClick}
                        />
                    )}
            </div>
        </Container>
    );
}

export default NavigationCard;
